import React, { FC } from 'react';
import { Box, FormControl, Text, TextFieldSize, Select } from '@bechtel/gds';
import { WorkWeekWindowProps } from '../types';
import { weekDayList } from './form-data';
import { find } from 'lodash';
import { InputTimeStyled } from './styled';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';

const Item = ({ item }: any) => {
  const { i18n } = useLingui();
  return (
    <Text size="400" color="grey.1000">
      {i18n._(item.name)}
    </Text>
  );
};

const SelectedItem = ({ item }: any) => {
  const { i18n } = useLingui();
  return (
    <Text size="400" color="grey.1000" family="graphik">
      {i18n._(item.name)}
    </Text>
  );
};

export const WorkWeekWindow: FC<WorkWeekWindowProps> = ({ label, formikProps, dayFieldName, timeFieldName }) => {
  const { setFieldValue, values } = formikProps;
  const dayFieldValue = values[dayFieldName];
  const timeFieldValue = values[timeFieldName];

  return (
    <Box data-testid={`work-week-${dayFieldName}`} mb={{ sm: '600' }} flexDirection={{ sm: 'column' }}>
      <Box mb={{ sm: '500' }}>
        <Text size="400" color="grey.1000">
          {label}
        </Text>
      </Box>
      <Box>
        <Box mr={{ sm: '600' }}>
          <FormControl label={t`Day`} style={{ width: '206px' }}>
            <Select
              selectedItem={find(weekDayList, (item) => {
                return item.id === dayFieldValue;
              })}
              itemComponent={Item}
              selectedComponent={SelectedItem}
              size={TextFieldSize.LARGE}
              items={weekDayList}
              onSelectedItemChange={async (changes) => {
                setFieldValue(dayFieldName, changes.selectedItem.id);
              }}
            />
          </FormControl>
        </Box>
        {/* TODO: Implement GDS timer control */}
        <FormControl label={t`Time`} style={{ width: '206px' }}>
          <InputTimeStyled
            value={timeFieldValue}
            onChange={(event) => {
              setFieldValue(timeFieldName, event.target.value);
            }}
          />
        </FormControl>
      </Box>
    </Box>
  );
};
